'use client';

import React from 'react';
import { ArrowLeft, Briefcase, Users, Bell } from 'lucide-react';
import type { HiringView, JobPosting } from '../page';

interface HiringHeaderProps {
  view: HiringView;
  selectedJob: JobPosting | null;
  onBack: () => void;
  totalJobs: number;
  totalApplicants: number;
  newApplicants: number;
}

export default function HiringHeader({
  view,
  selectedJob,
  onBack,
  totalJobs,
  totalApplicants,
  newApplicants,
}: HiringHeaderProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          {view === 'pipeline' && (
            <button
              onClick={onBack}
              className="p-1.5 rounded-lg border border-border bg-card hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft size={16} />
            </button>
          )}
          <div>
            {view === 'jobs' ? (
              <>
                <h1 className="text-xl font-700 text-foreground">Hiring</h1>
                <p className="text-sm text-muted-foreground mt-0.5">
                  Manage job postings and track applicants through the hiring pipeline
                </p>
              </>
            ) : (
              <>
                <h1 className="text-xl font-700 text-foreground">
                  {selectedJob?.title ?? 'Applicant Pipeline'}
                </h1>
                <p className="text-sm text-muted-foreground mt-0.5">
                  {selectedJob?.department} · {selectedJob?.location} · {selectedJob?.type}
                </p>
              </>
            )}
          </div>
        </div>

        {view === 'jobs' && (
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-2 bg-card border border-border rounded-lg">
              <Briefcase size={14} className="text-primary" />
              <span className="text-sm font-600 text-foreground">{totalJobs}</span>
              <span className="text-xs text-muted-foreground">Active Jobs</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-card border border-border rounded-lg">
              <Users size={14} className="text-primary" />
              <span className="text-sm font-600 text-foreground">{totalApplicants}</span>
              <span className="text-xs text-muted-foreground">Total Applicants</span>
            </div>
            {newApplicants > 0 && (
              <div className="flex items-center gap-2 px-3 py-2 bg-warning/10 border border-warning/30 rounded-lg">
                <Bell size={14} className="text-warning" />
                <span className="text-sm font-600 text-warning">{newApplicants}</span>
                <span className="text-xs text-warning/80">New</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
